import React from 'react';
import Tile from '../ui/Tile';
import TileHeader from '../ui/TileHeader';
import { Users } from 'lucide-react';
import ClientsListTable from './components/ClientsListTable';

const ClientsList = ({
  clients = [],
  handleUpdateClient,
  handleDelete,
  loadMore,
  sorting,
  setSorting,
  loadClientToForm
}) => {
  return (
    <div className="w-full mt-8">
      <Tile>
        <TileHeader title="Списък клиенти" icon={Users} />
        <div className="pt-6">
          <ClientsListTable 
            clients={clients}
            handleUpdateClient={handleUpdateClient}
            handleDelete={handleDelete}
            loadMore={loadMore}
            sorting={sorting}
            setSorting={setSorting}
            loadClientToForm={loadClientToForm}
          />
        </div>
      </Tile>
    </div>
  );
};

export default ClientsList;
